/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Err_Items_Min_OneInputs */

const vi_form_err_items_min_one = /** @type {(inputs: Form_Err_Items_Min_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu phải có ít nhất 1 lô`)
};

/**

* @param {Form_Err_Items_Min_OneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const form_err_items_min_one = /** @type {((inputs?: Form_Err_Items_Min_OneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Err_Items_Min_OneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_form_err_items_min_one(inputs)
});